import { AdminSection } from './types';

export const AdminSectionData: AdminSection = {
  project: [
    {
      title: 'General',
      path: 'general',
      id: 'general',
    },
    {
      title: 'Cables',
      path: 'cables',
      id: 'cable',
      displayMemberName: 'cable',
    },
    {
      title: 'Jumpers',
      path: 'jumpers',
      id: 'jumper',
      displayMemberName: 'jumper',
    },
    {
      title: 'Equipment',
      path: 'equipment',
      id: 'equipment',
      displayMemberName: 'equipment',
    },
    {
      title: 'Raceways',
      path: 'raceways',
      id: 'raceway',
      displayMemberName: 'raceway',
    },
    {
      title: 'Terminations',
      path: 'terminations',
      id: 'termination',
    },
  ],
  security: [
    {
      title: 'Users',
      path: 'users',
      displayMemberName: 'userAccount',
    },
    {
      title: 'Roles',
      path: 'roles',
      displayMemberName: 'role',
    },
    {
      title: 'Permissions',
      path: 'permissions',
      displayMemberName: 'permission',
    },
    {
      title: 'Restrictions',
      path: 'restrictions',
      displayMemberName: 'restriction',
    },
  ],
  settings: [
    {
      title: 'Service Levels',
      path: 'service-levels',
      displayMemberName: 'serviceLevelCable',
    },
    {
      title: 'Separation Groups',
      path: 'separation-groups',
      displayMemberName: 'separationGroupCable',
    },
    {
      title: 'Fill/Overfill Methods',
      path: 'fill-overfill-methods',
    },
    {
      title: 'Revision Card Columns',
      path: 'revision-card-columns',
    },
    {
      title: 'Optional Card Columns',
      path: 'optional-card-columns',
    },
    {
      title: 'Required Input Columns',
      path: 'required-input-columns',
    },
    {
      title: 'Change Control Columns',
      path: 'change-control-columns',
    },
    {
      title: 'Column Widths',
      path: 'column-widths',
    },
    {
      title: 'Section Lists',
      path: 'selection-lists',
      displayMemberName: 'selectList',
    },
    {
      title: 'USER_INTERFACE',
      path: 'user-interface',
    },
  ],
};
